import * as React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import styled from "@emotion/styled";
import { useNavigate, useParams } from "react-router-dom";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
const Text = styled(ListItemText)({
  textAlign: "right",
});
const ItemButton = styled(ListItemButton)({
  borderRadius: "10px",
  "& .MuiTypography-root": {
    fontFamily: "'Yekan !important'",
  },
  "& .MuiListItemIcon-root": {
    minWidth: "unset",
    marginLeft: ".5rem",
  },
});
const adminFacilities = [
  { name: "اعضا", icon: <PeopleAltIcon />, address: "members" },
  { name: "دوره ها", icon: <OndemandVideoIcon />, address: "courses" },
];
function OrgansMenuItems() {
  const [expand, setExpand] = React.useState(true);
  const navigate = useNavigate();
  const params = useParams() as { organ: string };
  return (
    <List
      sx={{ width: "100%", maxHeight: "80vh", overflow: "auto" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ItemButton
        onClick={() => setExpand(!expand)}
        sx={{ bgcolor: "primary.main" }}
      >
        <Text primary="دوره ها" />
        {expand ? <RemoveIcon /> : <AddIcon />}
      </ItemButton>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {adminFacilities.map((item, index) => {
            return (
              <ItemButton
                onClick={() =>
                  navigate(`/organs/${params?.organ}/${item.address}`)
                }
                key={index}
                sx={{ pl: 4 }}
              >
                <ListItemIcon sx={{ color: "divider" }}>
                  {item.icon}
                </ListItemIcon>
                <Text primary={item.name} />
              </ItemButton>
            );
          })}
        </List>
      </Collapse>
    </List>
  );
}
export default OrgansMenuItems;
